import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

export default function PhotoGalleryImage({ image, theme }) {
  const url = _.get(image, 'image.galleryImage');
  const description = _.get(image, 'description');

  if (!url || !description) return null;

  return (
    <div data-test="web-photo-gallery-image-container">
      <img
        alt={description}
        className={theme.image}
        data-test="web-photo-gallery-image"
        src={url}
      />
      <div className={theme.caption} data-test="web-photo-gallery-image-caption">
        {description}
      </div>
    </div>
  );
}

PhotoGalleryImage.propTypes = {
  image: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({}).isRequired,
};
